import React, { useState, useEffect } from 'react';
import { useAdmin } from "../../context/contextAdmin";
import { useThemeMode } from "../../context/contextTheme";

const AdminLogin = () => {
  const { theme, mode } = useThemeMode();
  const {
    credentials,
    setCredentials,
    getSigninAdmin,
    loadingAuthAdmin,
    error, setError
  } = useAdmin();

  useEffect(() => {
    document.body.style.backgroundImage = "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.minHeight = "100vh";
    document.body.style.margin = "0";
    document.body.style.display = "flex";
    document.body.style.alignItems = "center";
    document.body.style.justifyContent = "center";
  }, [mode, theme.background]);

  const handleChange = (e) => {
    if (error) setError(null);

    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    try {
      await getSigninAdmin(credentials);
    } catch (err) {
      console.log("Authentication failed.");
    }
  };

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center py-5">
      <div
        className="card border-0 shadow-lg p-4 p-sm-5 text-center w-100"
        style={{ maxWidth: '420px', borderRadius: '24px', backgroundColor: '#ffffff' }}
      >
        <div className="d-inline-flex align-items-center mx-auto mb-4 px-3 py-1 rounded-pill"
          style={{ backgroundColor: '#fff7ed', border: '1px solid #ffedd5', color: '#9a3412', fontSize: '11px', fontWeight: '800', letterSpacing: '0.5px' }}>
          <span className="me-2">🔒</span> SECURE ADMIN GATEWAY
        </div>

        <div className="mb-4">
          <h2 className="fw-black mb-0 fw-bold" style={{ letterSpacing: '-1px', color: '#1a1a5e' }}>
            SAVE <span style={{ color: '#0095ff' }}>ADMIN</span>
          </h2>
        </div>

        <p className="text-muted small mb-4">
          Identity verification required for administrative access.
        </p>

        {error && (
          <div className="alert alert-danger py-2 small mb-4" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleAdminLogin}>
          <div className="text-start mb-3">
            <label className="form-label small fw-bold text-secondary">Admin ID</label>
            <input
              type="text"
              name="username"
              className="form-control form-control-lg bg-light border-0"
              placeholder="admin_root"
              onChange={handleChange}
              required
              style={{ borderRadius: '10px', fontSize: '14px' }}
            />
          </div>

          <div className="text-start mb-4">
            <label className="form-label small fw-bold text-secondary">Security Token / Password</label>
            <input
              type="password"
              name="password"
              className="form-control form-control-lg bg-light border-0"
              placeholder="••••••••"
              onChange={handleChange}
              required
              style={{ borderRadius: '10px', fontSize: '14px' }}
            />
          </div>

          <button
            type="submit"
            className="btn btn-lg w-100 text-white fw-bold shadow-sm"
            style={{ backgroundColor: '#0095ff', borderRadius: '12px', border: 'none', padding: '14px' }}
          >
            {loadingAuthAdmin ? 'Authenticating...' : 'Authenticate'}
          </button>
        </form>

        <div className="mt-4">
          <a href="/save" className="text-decoration-none small text-primary fw-medium">
            ← Return to Main Portal
          </a>
        </div>

        <div className="border-top pt-3 mt-4">
          <p className="text-muted mb-0" style={{ fontSize: '11px' }}>
            System activity is being monitored and logged.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;